export default {
    // BASE_URL: 'http://localhost/ratis-api/public', //dev
    // BASE_URL: 'http://192.168.21.20:8002', //staging
    BASE_URL: 'https://api2.ratis.de', //live
    TRACKING_URL: 'https://ratis.de/', //TODO: add correct url
}
